import { render, staticRenderFns } from "./project-item-builder.vue?vue&type=template&id=1c10d988&"
import script from "./project-item-builder.vue?vue&type=script&lang=js&"
export * from "./project-item-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports